const parse = (s) => new Date(s && s.length === 10 ? `${s}T12:00:00` : s);

export const fmtDate = (s) =>
  s ? parse(s).toLocaleDateString("it-IT", { day: "numeric", month: "short", year: "numeric" }) : "—";
export const fmtDateTime = (s) =>
  s ? parse(s).toLocaleString("it-IT", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtTime = (s) => (s ? parse(s).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : "");
export const fmtEuro = (n) =>
  n == null ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 2, useGrouping: "always" }).format(n);

export const PROVENIENZE = ["Instagram", "Facebook", "Altri social", "Passaparola", "Google / ricerca online", "Sito web", "Showroom / negozio", "Cliente già acquisito", "Volantino / cartellone", "Fiera / evento", "Altro"];
export const TIPOLOGIE = { appartamento: "Appartamento in condominio", attico: "Attico", villa: "Villa", villetta_schiera: "Villetta a schiera", casa_indipendente: "Casa indipendente", loft: "Loft", negozio_ufficio: "Negozio / ufficio", altro: "Altro" };
export const PARCHEGGI = { facile: "Facile", difficile: "Difficile", a_pagamento: "A pagamento", cortile_privato: "In cortile privato", pass_necessario: "Serve pass/permesso" };
export const LOGI_BOOL = { cortile_scarichi: "Cortile interno per scarichi", spazio_cassone: "Spazio per cassone su strada", occupazione_suolo: "Serve occupazione suolo pubblico", montacarichi: "Serve montacarichi", portineria: "Portineria / custode", acqua_luce: "Acqua e luce disponibili", vicini_da_avvisare: "Vicini da avvisare" };
export const LOGI_TXT = { ascensore_note: "Ascensore (misure, portata)", scale_note: "Scale (larghezza, rampe)", orari_condominio: "Orari consentiti dal condominio", accesso_note: "Accesso (chiavi, citofono, codici)", note: "Altre note logistiche" };




export const APPT_TYPES = [
  { v: "sopralluogo", l: "Sopralluogo" },
  { v: "in_sede", l: "In sede" },
  { v: "cantiere", l: "In cantiere" },
  { v: "videochiamata", l: "Videochiamata" },
];
export const apptTypeLabel = (v) => APPT_TYPES.find((t) => t.v === v)?.l || v;
export const APPT_STATUS = { richiesto: "Richiesto", confermato: "Confermato", annullato: "Annullato", completato: "Completato" };
export const APPT_TONE = { richiesto: "warning", confermato: "success", annullato: "error", completato: "muted" };

export const DOC_CATEGORIES = [
  { v: "preventivo", l: "Preventivi" },
  { v: "progetto", l: "Progetti" },
  { v: "contratto", l: "Contratti" },
  { v: "pratica", l: "Pratiche" },
  { v: "altro", l: "Altro" },
];
export const DOC_STATUS = { pending: "Da approvare", accepted: "Accettato", rejected: "Rifiutato" };
export const DOC_TONE = { pending: "warning", accepted: "success", rejected: "error" };

export const CANTIERE_STATUS = { attivo: "Attivo", sospeso: "Sospeso", completato: "Completato" };
export const CANTIERE_TONE = { attivo: "success", sospeso: "warning", completato: "muted" };
export const PHASE_STATUS = { todo: "Da iniziare", active: "In corso", done: "Completata" };
export const PHASE_TONE = { todo: "muted", active: "sand", done: "success" };

export const LEAD_STATUS = [
  { v: "nuovo", l: "Nuovo" },
  { v: "contattato", l: "Contattato" },
  { v: "sopralluogo", l: "Sopralluogo" },
  { v: "chiuso", l: "Chiuso" },
];

export const WORK_TYPES = ["Ristrutturazione completa", "Bagno", "Cucina", "Impianti", "Facciata / condominio", "Property flipping", "Altro"];
export const BUDGETS = ["< 20k", "20-50k", "50-100k", "> 100k", "Da definire"];
export const TIMES = ["09:00", "10:00", "11:00", "12:00", "14:30", "15:30", "16:30", "17:30"];

export const COMPANY = {
  name: "RP Home",
  address: "Corso Racconigi 6 bis, 10138 Torino",
  maps: "https://www.google.com/maps/search/?api=1&query=Corso+Racconigi+6+bis+10138+Torino",
  site: "https://www.rphome.it",
  instagram: "https://www.instagram.com/rphome.it/",
};

export const greeting = () => {
  const h = new Date().getHours();
  return h < 13 ? "Buongiorno" : h < 18 ? "Buon pomeriggio" : "Buonasera";
};

export const suggestPassword = () => `RPHome${Math.floor(1000 + Math.random() * 9000)}!`;


export const QUOTE_STATUS = { bozza: "Bozza", inviato: "Inviato", in_trattativa: "In trattativa", accettato: "Accettato", rifiutato: "Rifiutato", scaduto: "Scaduto" };
export const QUOTE_TONE = { bozza: "muted", inviato: "sand", in_trattativa: "warning", accettato: "success", rifiutato: "error", scaduto: "muted" };
export const QUOTE_CATEGORIES = { ristrutturazione: "Ristrutturazione completa", bagno: "Bagno", cucina: "Cucina", impianti: "Impianti", facciata: "Facciata / condominio", flipping: "Property flipping", altro: "Altro" };
export const CALL_OUTCOMES = { non_risponde: "Non risponde", da_richiamare: "Da richiamare", interessato: "Interessato", non_interessato: "Non interessato" };
export const LADDER = { non_serve: "Non serve", senza_permessi: "Senza permessi", con_permessi: "Con permessi" };
export const ORDER_STEPS = [
  ["contratto_registrato", "Contratto registrato"], ["acconto_ricevuto", "Acconto ricevuto"], ["rilievo_programmato", "Rilievo misure programmato"],
  ["rilievo_completato", "Rilievo misure completato"], ["conferma_progetto_fissata", "Appuntamento di conferma progetto fissato"],
  ["progetto_confermato", "Progetto confermato"], ["ordine_inviato", "Ordine materiali inviato"], ["arrivo_previsto", "Arrivo materiali previsto"],
  ["merce_arrivata", "Materiali arrivati"], ["inizio_lavori", "Inizio lavori"], ["saldo_registrato", "Saldo registrato"], ["consegna_programmata", "Fine lavori programmata"],
  ["consegna_completata", "Fine lavori completata"], ["sospesa", "Sospesa"], ["annullata", "Annullata"],
];
export const ORDER_TONE = (s) => (s === "consegna_completata" ? "success" : s === "sospesa" ? "warning" : s === "annullata" ? "muted" : "sand");
export const ORDER_APPT_KINDS = { sopralluogo: "Sopralluogo preliminare", rilievo: "Rilievo misure", conferma_progetto: "Conferma progetto", consegna: "Verbale di fine lavori", intervento: "Intervento dopo la fine lavori", completamento: "Completamento lavori" };
export const ORDER_APPT_STATUS = { programmato: "Programmato", completato: "Completato", riprogrammato: "Riprogrammato", annullato: "Annullato" };
export const ISSUE_STATUS = { aperta: "Aperta", in_riordino: "In riordino", materiale_arrivato: "Materiale arrivato", risolta: "Risolta" };
export const PAY_METHODS = { bonifico: "Bonifico", contanti: "Contanti", carta: "Carta", finanziamento: "Finanziamento", non_indicato: "Non indicata" };
export const yesNo = (v) => (v == null ? "—" : v ? "Sì" : "No");
export const addDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toLocaleDateString("en-CA");
};
export const todayIso = () => new Date().toLocaleDateString("en-CA");
export const fmtDay = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "—");
